import { Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import { JuniorAliveNavProvider } from './contexts/JuniorAliveNavContext';
import WelcomePage from './pages/Welcome';
import HomePage from './pages/Home';
import RitmoHubPage from './pages/hubs/RitmoHub';
import MelodiaHubPage from './pages/hubs/MelodiaHub';
import EscucharHubPage from './pages/hubs/EscucharHub';
import MiniJuegosHubPage from './pages/hubs/MiniJuegosHub';
import HerramientasHubPage from './pages/hubs/HerramientasHub';
import AtrapaRitmoPage from './pages/ritmo/AtrapaRitmo';
import EcoRitmicoPage from './pages/ritmo/EcoRitmico';
import BoomPracticaRitmosPage from './pages/ritmo/BoomPracticaRitmos';
import BoomDescubreRitmoPage from './pages/ritmo/BoomDescubreRitmo';

import ConstructorMelodiasPage from './pages/melodia/ConstructorMelodias';
import ClingCantaPage from './pages/melodia/ClingCanta';
import BoomPatronesPage from './pages/melodia/BoomPatrones';
import MusicalCloudTetrisPage from './pages/mini-juegos/MusicalCloudTetris';

export default function JuniorApp() {
  return (
    <JuniorAliveNavProvider>
      <Routes>
        <Route path="/" element={<WelcomePage />} />
        <Route path="/home" element={<HomePage />} />

        <Route path="/ritmo" element={<RitmoHubPage />} />
        <Route path="/ritmo/atrapa-el-ritmo" element={<AtrapaRitmoPage />} />
        <Route path="/ritmo/eco-ritmico" element={<EcoRitmicoPage />} />
        <Route path="/ritmo/practica-ritmos" element={<BoomPracticaRitmosPage />} />
        <Route path="/ritmo/descubre-el-ritmo" element={<BoomDescubreRitmoPage />} />

        <Route path="/melodia" element={<MelodiaHubPage />} />
        <Route path="/melodia/constructor" element={<ConstructorMelodiasPage />} />
        <Route path="/melodia/cling-canta" element={<ClingCantaPage />} />
        <Route path="/melodia/boom-patrones" element={<BoomPatronesPage />} />

        <Route path="/escuchar" element={<EscucharHubPage />} />
        <Route path="/mini-juegos" element={<MiniJuegosHubPage />} />
        <Route path="/mini-juegos/musical-cloud-tetris" element={<MusicalCloudTetrisPage />} />
        <Route path="/herramientas" element={<HerramientasHubPage />} />

        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </JuniorAliveNavProvider>
  );
}
